import React, { Component, PropTypes } from 'react'
import Helmet from 'react-helmet'
import { Link as RouterLink } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import { config } from 'config'

import { colors, breakpoints } from '../constants/theme'

import Section from '../components/Section'
import Column from '../components/Column'
import Row from '../components/Row'
import Spacer from '../components/Spacer'
import Container from '../components/Container'
import Page from '../components/Page'
import Icon from '../components/Icon'
import Image from '../components/Image'

import Heading1 from '../styleguide/Heading1'
import Heading2 from '../styleguide/Heading2'
import Heading3 from '../styleguide/Heading3'
import Heading4 from '../styleguide/Heading4'
import Heading5 from '../styleguide/Heading5'
import Heading6 from '../styleguide/Heading6'
import Paragraph from '../styleguide/Paragraph'
import Navigation from '../styleguide/Navigation'
import Link from '../styleguide/Link'
import LinkList from '../styleguide/LinkList'
import Footer from '../styleguide/Footer'
import Subtext from '../styleguide/Subtext'
import Services from '../styleguide/Services'
import Quote from '../styleguide/Quote'
import QuoteAuthor from '../styleguide/QuoteAuthor'
import Button from '../styleguide/Button'
import Line from '../styleguide/Line'

import FelaProvider from '../containers/FelaProvider'

const { min1920, min1440, min1024, min768, min480, min360 } = breakpoints

const metaData = [
  {
    name: 'description',
    content:
      'Wir konzipieren, designen, entwickeln und betreiben anspruchsvolle Applikationen sowie komplexe und skalierbare Client-Server Systeme auf aktuellsten Web Stacks.'
  },
  {
    name: 'keywords',
    content: 'web agency'
  }
]

const Navigator = () => (
  <Page
    id="navigation"
    style={{
      position: 'fixed',
      zIndex: 10,
      transformStyle: 'preserve-3d'
    }}
  >
    <Container color="white" flex="0 0 auto">
      <Helmet title="Ninja Concept | Sophisticated web &amp; mobile applications" meta={metaData} />
      <Row alignItems="center" justifyContent="flex-start" style={{ alignItems: 'flex-start' }}>
        <Column
          style={{
            flexDirection: 'row',
            justifyContent: 'flex-start'
          }}
          alignItems="center"
        >
          <img
            src={prefixLink('/images/logo/logo_ninjaconcept_horizontal.svg')}
            style={{ cursor: 'pointer' }}
            onClick={() => (window.location.pathname = '/')}
          />
          <Spacer size={20} />
          <RouterLink to={prefixLink('/')}>
            <Navigation
              bold
              color="white"
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'flex-start'
              }}
            >
              <i
                className="fa fa-angle-left"
                aria-hidden="true"
                style={{
                  fontSize: 30,
                  marginTop: -4
                }}
              />
              <Spacer size={6} /> HOME
            </Navigation>
          </RouterLink>
        </Column>
      </Row>
    </Container>
  </Page>
)

const Impressum = (props, { width }) => (
  <FelaProvider>
    <Navigator />
    <Image
      id="headerImage"
      style={{ width: '100%' }}
      jpg
      base={prefixLink('/images/images/impressum')}
      sizes={[min360, min480, min768, min1024, min1440]}
    />
    <Page bgColor={colors.background}>
      <Container flex="1 0 auto" color="white">
        <Spacer size={60} sizes={{ [min1024]: 100 }} />
        <Row columns={{ [min1920]: 12 }}>
          <Column style={{ alignItems: 'flex-start' }} sizes={{ [min1920]: 12 }}>
            <Heading2 style={{ textAlign: 'left' }}>Impressum</Heading2>
          </Column>
        </Row>
        <Spacer size={40} />
        <Row
          columns={{ [min1024]: 12 }}
          style={{ flexDirection: width < min1024 ? 'column' : 'row' }}
        >
          <Column sizes={{ [min1024]: 6 }} style={{ alignItems: 'flex-start' }}>
            <Heading5 style={{ textAlign: 'left' }}>Angaben gemäß § 5 TMG:</Heading5>
            <Spacer size={6} sizes={{ [min1920]: 6 }} />
            <Paragraph style={{ textAlign: 'left' }}>
              NinjaConcept GmbH
              <br />Hardtstraße 37A
              <br />76185 Karlsruhe, Deutschland
              <br />
              <br />
              Fon:{' '}
              <a href="tel:+49 721 1803523 0" style={{ fontFamily: 'lora' }}>
                +49 721 1803523-0
              </a>
              <br />Fax: +49 721 1803523-9
              <br />
              E-Mail:{' '}
              <a href="mailto:info@ninjaconcept.com" style={{ fontFamily: 'lora' }}>
                info@ninjaconcept.com
              </a>
            </Paragraph>
          </Column>
          <Spacer size={40} sizes={{ [min1024]: 0 }} />
          <Column sizes={{ [min1024]: 6 }} style={{ alignItems: 'flex-start' }}>
            <Heading5 style={{ textAlign: 'left' }}>Vertreten durch:</Heading5>
            <Spacer size={6} sizes={{ [min1920]: 6 }} />
            <Paragraph style={{ textAlign: 'left' }}>
              Marco Sehrer
              <br />
              <br />Amtsgericht Mannheim, Germany
              <br />Handelsregister: 709322
              <br />UST ID: DE272763093
            </Paragraph>
          </Column>
        </Row>
        <Spacer
          size={60}
          sizes={{
            [min1024]: 100,
            [min1920]: 120
          }}
        />
      </Container>
    </Page>
    <Spacer size={100} />
    <Line width="100%" stroke={1} color="rgba(255, 255, 255, 0.4)" />
    <Page height="0%" data-scroll-scope="contact" bgColor={colors.background}>
      <Spacer size={160} />
      <Container color="white" flex="1 0 auto">
        <Row center>
          <Column>
            <Section alignSelf="stretch" flex="1 0 auto" center>
              <Image svg base={prefixLink('/images/logo/logo_ninjaconcept_horizontal')} />
            </Section>
            <Spacer size={64} />
            <Footer bold textAlign="center">
              © 2016-2024 NinjaConcept GmbH
            </Footer>
            <Footer textAlign="center">
              The design of ninjaconcept is a registered trademark of NinjaConcept GmbH.
              <br />Hardtstraße 37A, 76185 Karlsruhe, Germany
            </Footer>
            <Section flex alignSelf="stretch" center row columnOnSmall>
              <Footer bold>
                <a href="tel:+49 721 180 352 30">+49 721 180 352 30</a>
              </Footer>
              <Spacer size={0} sizes={{ [min768]: 18 }} />
              <Footer bold>
                <a href="mailto:contact@ninjaconcept.com">contact@ninjaconcept.com</a>
              </Footer>
              <Spacer size={0} sizes={{ [min768]: 18 }} />
              <Footer bold color="gray">
                Impressum
              </Footer>
              <Spacer size={0} sizes={{ [min768]: 18 }} />
              <RouterLink to={prefixLink('/datenschutz/')}>
                <Footer bold>Datenschutzerklärung</Footer>
              </RouterLink>
            </Section>
            <Spacer
              size={40}
              sizes={{
                [min768]: 48,
                [min1440]: 60
              }}
            />
          </Column>
        </Row>
      </Container>
      <Spacer
        size={60}
        sizes={{
          [min1440]: 68,
          [min1920]: 76
        }}
      />
    </Page>
  </FelaProvider>
)

Impressum.contextTypes = { width: PropTypes.number }

class DeviceProvider extends Component {
  static childContextTypes = { width: PropTypes.number }

  constructor(props, context) {
    super(props, context)
    this.distance = 0
    this.state = { width: 0 }
  }

  updateDevice = () => {
    this.setState({ width: window.innerWidth })
  }

  draw = () => {
    window.requestAnimationFrame(this.draw)
    this.animate()
  }

  animate = () => {
    const scrollTop = this.mount.scrollTop

    const offset =
      scrollTop > this.mount.scrollHeight - window.innerHeight ? 0 : this.lastScrollTop - scrollTop

    const newDirection = offset < 0 ? 'down' : offset > 0 ? 'up' : this.direction

    if (newDirection === this.direction && Date.now() >= window.IS_SCROLLING) {
      this.distance += Math.abs(offset)
    } else {
      this.distance = 0
    }

    if (Date.now() > window.LAST_SCROLL + 1000) {
      this.distance = 0
    }

    this.direction = newDirection

    this.lastScrollTop = scrollTop
    const scrollPercentage = scrollTop / (this.headerImage.offsetHeight - 40)

    this.nav.style.backgroundColor = `rgba(22, 24, 28, ${Math.max(
      0,
      Math.min(1.0, scrollPercentage)
    )})`

    if (this.direction === 'up' && this.distance > 200) {
      (this.nav.style.transition = '200ms transform linear'),
        (this.nav.style.transform = 'translate3d(0, 0, 0)')
    }

    if (
      ((this.direction === 'down' && this.distance > 70) ||
        Date.now() > window.LAST_SCROLL + 3500) &&
      scrollTop > this.headerImage.offsetHeight - 40
    ) {
      (this.nav.style.transition = '200ms transform linear'),
        (this.nav.style.transform = `translate3d(0, -${this.nav.offsetHeight}px, 0)`)
    }

    window.LAST_SCROLL = Date.now()
  }

  getChildContext() {
    return { width: this.state.width }
  }

  componentDidMount() {
    this.mount = document.getElementById('react-mount')
    this.nav = document.getElementById('navigation')
    this.nav.classList.add('animated')
    this.headerImage = document.getElementById('headerImage')
    this.lastScrollTop = this.mount.scrollTop
    window.IS_SCROLLING = Date.now()

    this.draw()
    this.updateDevice()

    window.addEventListener('resize', () => {
      this.updateDevice()
    })
  }

  render() {
    return this.props.children
  }
}

export default () => (
  <DeviceProvider>
    <Impressum />
  </DeviceProvider>
)



// WEBPACK FOOTER //
// ./impressum.js